export default [

    // Room
    { name: 'roomModel', type: 'gltfModel', path: 'models/room/model.glb' },
    { name: 'roomShadowModel', type: 'gltfModel', path: 'models/room/shadow-model.glb' },
    { name: 'bakedRoomTexture', type: 'texture', path: 'models/room/baked.jpg' },
    { name: 'bakedShadowRoomTexture', type: 'texture', path: 'models/room/shadow-baked.jpg' },
    { name: 'tone0Texture', type: 'texture', path: 'textures/sprites/tone-0.png' },
    { name: 'tone1Texture', type: 'texture', path: 'textures/sprites/tone-1.png' },
    { name: 'tone2Texture', type: 'texture', path: 'textures/sprites/tone-2.png' },
    { name: 'heartTexture', type: 'texture', path: 'textures/sprites/heart.png' },

    //Character
    { name: 'characterModel', type: 'gltfModel', path: 'models/character/model.glb' },

    //Character Textures
    { name: 'shirtMatcap', type: 'texture', path: 'textures/matcaps/shirt.jpg' },
    { name: 'skinMatcap', type: 'texture', path: 'textures/matcaps/skin.jpg' },
    { name: 'pantsMatcap', type: 'texture', path: 'textures/matcaps/pants.jpg' },
    { name: 'whiteMatcap', type: 'texture', path: 'textures/matcaps/white.jpg' },
    { name: 'bakedCharacterHeadTexture', type: 'texture', path: 'models/character/head-baked.jpg' },

    //Character Faces
    { name: 'characterDefaultFace', type: 'texture', path: 'models/character/faces/default.png' },
    { name: 'characterBlink0Face', type: 'texture', path: 'models/character/faces/blink-0.png' },
    { name: 'characterBlink1Face', type: 'texture', path: 'models/character/faces/blink-1.png' },
    { name: 'characterSmile0Face', type: 'texture', path: 'models/character/faces/smile/0.png' },
    { name: 'characterSmile1Face', type: 'texture', path: 'models/character/faces/smile/1.png' },
    { name: 'characterSmile2Face', type: 'texture', path: 'models/character/faces/smile/2.png' },
    { name: 'characterScaredFace', type: 'texture', path: 'models/character/faces/scared.png' },
    { name: 'characterSleepyFace', type: 'texture', path: 'models/character/faces/sleepy.png' },
    { name: 'characterContact1Face', type: 'texture', path: 'models/character/faces/contact/1.png' },
    { name: 'characterContact2Face', type: 'texture', path: 'models/character/faces/contact/2.png' },

    //Destkops
    { name: 'desktop0', type: 'texture', path: 'models/room/desktops/0.png' },
    { name: 'desktop1', type: 'texture', path: 'models/room/desktops/1.png' },
    { name: 'newMessageSprite', type: 'texture', path: 'textures/sprites/new-message.png' },
    { name: 'desktop1Notification', type: 'texture', path: 'models/room/desktops/1-notification.png' },

    //Lab
    { name: 'labModel', type: 'gltfModel', path: 'models/lab/model.glb' },
    { name: 'labShadowModel', type: 'gltfModel', path: 'models/lab/shadow-model.glb' },
    { name: 'bakedShadowLabTexture', type: 'texture', path: 'models/lab/shadow-baked.jpg' },
    { name: 'bakedLabTexture', type: 'texture', path: 'models/lab/baked.jpg' },
    { name: 'labScreenGraph', type: 'texture', path: 'models/lab/screen-graph.jpg' },
    { name: 'labScreenOffline', type: 'texture', path: 'models/lab/screen-offline.jpg' },
    { name: 'bubbleSprite', type: 'texture', path: 'textures/sprites/bubble.png' },
    { name: 'bubblePopSprite', type: 'texture', path: 'textures/sprites/bubble-pop.png' },

    //Contact Scene
    { name: 'contactSceneModel', type: 'gltfModel', path: 'models/contact/model.glb' },
    { name: 'bakedContactTexture', type: 'texture', path: 'models/contact/baked.jpg' },
    { name: 'contactShadowModel', type: 'gltfModel', path: 'models/contact/shadow-model.glb' },
    { name: 'bakedShadowContactTexture', type: 'texture', path: 'models/contact/shadow-baked.jpg' },
    { name: 'davidImage', type: 'texture', path: 'images/david.png' },
]